export default __webpack_public_path__ + "static/media/logo-with-words-dark-bg.57682a94.png";